var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-box"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"val",style:('width: '+ _vm.progressVal +'%')})])])])}
var staticRenderFns = []

export { render, staticRenderFns }